export class NumberFormat {
   /**
    *
    * @param {*} num =>
    * @returns
    */
   static formatNumber(num) {
      if (+num) {
         let formattedNumber = Math.round(num)
            .toString()
            .replace(/(\d)(?=(\d\d)+\d$)/g, '$1,');
         return formattedNumber;
      } else {
         return 0;
      }
   }

   static decimalToPercentage(num) {
      if (+num) {
         let percentageValue = (Math.round(num * 100 * 100) / 100).toFixed(2);
         return percentageValue;
      } else {
         return 0;
      }
   }
   static roundToDecimal(number) {
      if (+number) {
         let percentageVal = Math.round(number * 100) / 100;
         return percentageVal;
      } else {
         return 0;
      }
   }
   static tabTitle(newTitle) {
      if (newTitle) {
         let titleNew = (document.title = newTitle);
         return titleNew;
      } else {
         return 'Login';
      }
   }
}
